import {
  DrivDiv,
  DriveModeDiv,
  DriveModeFlex,
  DriveNameDiv
} from 'modules/Exp-Candidates/ViewDrive/DriveRightPart/style'
import React from 'react'

const DriveRight = ({ driveRolesMetrics }) => {
  
const yearOfPassingArray = driveRolesMetrics[0]?.yearOfPassing
const lastValue = yearOfPassingArray?.[yearOfPassingArray.length - 1]
const firstValue = driveRolesMetrics[0]?.yearOfPassing[0]
const endDateString = driveRolesMetrics[0]?.endDate
if (endDateString) {
  const date = new Date(endDateString)
  const options = { day: 'numeric', month: 'short', year: 'numeric' }
  const formattedDate = date.toLocaleDateString('en-US', options)


  return (
    <div>
      <DrivDiv>Role Details</DrivDiv>
      <DriveModeFlex column>
        <DriveModeDiv>Year Of Passing</DriveModeDiv>
        <DriveNameDiv>{firstValue}-{lastValue}</DriveNameDiv>
      </DriveModeFlex>
      <DriveModeFlex column>
        <DriveModeDiv>Salary</DriveModeDiv>
        <DriveNameDiv>{driveRolesMetrics[0]?.minCompensation === driveRolesMetrics[0]?.maxCompensation ? driveRolesMetrics[0]?.maxCompensation : driveRolesMetrics[0]?.minCompensation +'-' +driveRolesMetrics[0]?.maxCompensation}</DriveNameDiv>
      </DriveModeFlex>
      <DriveModeFlex column>
        <DriveModeDiv>Last Date to Apply</DriveModeDiv>
        <DriveNameDiv>
          { formattedDate}
        </DriveNameDiv>
      </DriveModeFlex>
      <DriveModeFlex column>
        <DriveModeDiv> No breaks added </DriveModeDiv>
        
      </DriveModeFlex>
      
    </div>
  )
    }
}

export default DriveRight
